export const roleName = [
  { en: "Super Admin", gu: "સુપર એડમીન" },
  { en: "Admin", gu: "એડમીન" },
];

export const getGujaratiRoleName = (en: string): string | undefined =>
  roleName.find((role) => role.en === en)?.gu;
